import { type App } from 'vue'
import AppBadge from './app-badge.vue'
import AppButton from './app-button.vue'
import AppButtonBack from './app-button-back.vue'
import AppButtonCopy from './app-button-copy.vue'
import AppCard from './app-card.vue'
import AppCheckbox from './app-checkbox.vue'
import AppDropdown from './app-dropdown.vue'
import AppEmpty from './app-empty.vue'
import AppErrorMsg from './app-error-msg.vue'
import AppFilterBar from './app-filter-bar.vue'
import AppForm from './app-form.vue'
import AppFormSection from './app-form-section.vue'
import AppImage from './app-image.vue'
import AppInput from './app-input.vue'
import AppInputFile from './app-input-file.vue'
import AppInputNumber from './app-input-number.vue'
import AppInputPassword from './app-input-password.vue'
import AppInputSerialNumbers from './app-input-serial-numbers.vue'
import AppLabelNew from './app-label-new.vue'
import AppNotice from './app-notice.vue'
import AppPagination from './app-pagination.vue'
import AppRadio from './app-radio.vue'
import AppRouterView from './app-router-view.vue'
import AppSearch from './app-search.vue'
import AppSearchPage from './app-search-page.vue'
import AppSelect from './app-select.vue'
import AppSubmenuItem from './app-submenu.vue'
import AppSubmenu from './app-submenu-item.vue'
import AppSubmit from './app-submit.vue'
import AppDatePicker from './datepicker/app-date-picker.vue'
import AppDateRangePicker from './datepicker/app-date-range-picker.vue'
import FaIcon from './fa-icon.vue'
import Modal from './modal'
import PageFilter from './page-filter'
import AppTable from './table/app-table.vue'
import AppTableCheckable from './table/app-table-checkable.vue'
import AppTableInfo from './table/app-table-info.vue'
import AppTableInfoRow from './table/app-table-info-row.vue'

export default {
  install (app: App) {
    app.component('AppBadge', AppBadge)
    app.component('AppButton', AppButton)
    app.component('AppButtonBack', AppButtonBack)
    app.component('AppButtonCopy', AppButtonCopy)
    app.component('AppCard', AppCard)
    app.component('AppCheckbox', AppCheckbox)
    app.component('AppDatePicker', AppDatePicker)
    app.component('AppDateRangePicker', AppDateRangePicker)
    app.component('AppDropdown', AppDropdown)
    app.component('AppErrorMsg', AppErrorMsg)
    app.component('AppEmpty', AppEmpty)
    app.component('AppFilterBar', AppFilterBar)
    app.component('AppForm', AppForm)
    app.component('AppFormSection', AppFormSection)
    app.component('AppImage', AppImage)
    app.component('AppInput', AppInput)
    app.component('AppInputFile', AppInputFile)
    app.component('AppInputNumber', AppInputNumber)
    app.component('AppInputPassword', AppInputPassword)
    app.component('AppInputSerialNumbers', AppInputSerialNumbers)
    app.component('AppLabelNew', AppLabelNew)
    app.component('AppNotice', AppNotice)
    app.component('AppPagination', AppPagination)
    app.component('AppRadio', AppRadio)
    app.component('AppRouterView', AppRouterView)
    app.component('AppSearch', AppSearch)
    app.component('AppSearchPage', AppSearchPage)
    app.component('AppSelect', AppSelect)
    app.component('AppSubmit', AppSubmit)
    app.component('AppTable', AppTable)
    app.component('AppTableInfo', AppTableInfo)
    app.component('AppTableInfoRow', AppTableInfoRow)
    app.component('AppTableCheckable', AppTableCheckable)
    app.component('AppSubmenu', AppSubmenu)
    app.component('AppSubmenuItem', AppSubmenuItem)
    app.component('FaIcon', FaIcon)
    app.use(Modal)
    app.use(PageFilter)
  },
}

declare module 'vue' {
  export interface GlobalComponents {
    AppBadge: typeof AppBadge,
    AppButton: typeof AppButton,
    AppButtonBack: typeof AppButtonBack,
    AppButtonCopy: typeof AppButtonCopy,
    AppCard: typeof AppCard,
    AppCheckbox: typeof AppCheckbox,
    AppDropdown: typeof AppDropdown,
    AppDatePicker: typeof AppDatePicker,
    AppDateRangePicker: typeof AppDateRangePicker,
    AppErrorMsg: typeof AppErrorMsg,
    AppEmpty: typeof AppEmpty,
    AppFilterBar: typeof AppFilterBar,
    AppForm: typeof AppForm,
    AppFormSection: typeof AppFormSection,
    AppImage: typeof AppImage,
    AppInput: typeof AppInput,
    AppInputFile: typeof AppInputFile,
    AppInputNumber: typeof AppInputNumber,
    AppInputPassword: typeof AppInputPassword,
    AppInputSerialNumbers: typeof AppInputSerialNumbers,
    AppLabelNew: typeof AppLabelNew,
    AppNotice: typeof AppNotice,
    AppPagination: typeof AppPagination,
    AppRadio: typeof AppRadio,
    AppRouterView: typeof AppRouterView,
    AppSearch: typeof AppSearch,
    AppSearchPage: typeof AppSearchPage,
    AppSelect: typeof AppSelect,
    AppSubmit: typeof AppSubmit,
    AppTable: typeof AppTable,
    AppTableCheckable: typeof AppTableCheckable,
    AppTableInfo: typeof AppTableInfo,
    AppTableInfoRow: typeof AppTableInfoRow,
    AppSubmenu: typeof AppSubmenu,
    AppSubmenuItem: typeof AppSubmenuItem,
    FaIcon: typeof FaIcon,
  }
}
